<template>
  <div class="spinner-container" :class="containerClass">
    <div class="spinner" :class="sizeClass" :style="spinnerStyle"></div>
    <div v-if="text" class="spinner-text" :style="textStyle">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    // 尺寸: 'small' | 'medium' | 'large'
    size: {
      type: String,
      default: 'small',
      validator: (value) => ['small', 'medium', 'large'].includes(value)
    },
    // 自定义颜色
    color: {
      type: String,
      default: '#8E8E93'
    },
    // 可选的文本
    text: {
      type: String,
      default: ''
    },
    // 文本颜色
    textColor: {
      type: String,
      default: '#8E8E93'
    },
    // 是否居中显示
    centered: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    containerClass() {
      return {
        'spinner-centered': this.centered
      };
    },
    sizeClass() {
      return `spinner-${this.size}`;
    },
    spinnerStyle() {
      return {
        borderTopColor: this.color,
        borderRightColor: `${this.color}40`,
        borderBottomColor: `${this.color}40`,
        borderLeftColor: `${this.color}40`
      };
    },
    textStyle() {
      return {
        color: this.textColor
      };
    }
  }
}
</script>

<style lang="scss" scoped>
.spinner-container {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;

  &.spinner-centered {
    justify-content: center;
    align-items: center;
  }
}

.spinner {
  display: inline-block;
  border-radius: 50%;
  border-style: solid;
  animation: spinner-rotate 0.8s linear infinite;

  // 与 React Native ActivityIndicator 的尺寸保持一致
  &.spinner-small {
    width: 20px;
    height: 20px;
    border-width: 2px;
  }

  &.spinner-medium {
    width: 28px;
    height: 28px;
    border-width: 3px;
  }

  &.spinner-large {
    width: 36px;
    height: 36px;
    border-width: 3px;
  }
}

.spinner-text {
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  user-select: none;
}

@keyframes spinner-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
